/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  FormRootSchema,
  FormState,
  FormStateSchema,
} from '@gh/builder-shared';
import { DateTimeTypes } from '@gh/common-shared';
import { ContactDetailsCreditorSubContractor } from '../../resources/model/contact-details-creditor.model';

@Injectable()
export class ContactDetailsCreditorSubContractorFormState extends FormState<ContactDetailsCreditorSubContractor> {
  constructor(schemaFactory: BuilderFormSchemaFactory) {
    super(schemaFactory);
  }

  protected buildSchema(subContractor: ContactDetailsCreditorSubContractor,
                        { root, group, array }: FormStateSchema): FormRootSchema {
    return root({
      children: {
        contract: group({
          children: {
            contractStart: { type: DateTimeTypes.ShortDate },
            contractEnd: { type: DateTimeTypes.ShortDate },
            contractSent: { type: DateTimeTypes.ShortDate },
            contractReceived: { type: DateTimeTypes.ShortDate },
          },
        }),
        insurance: group({
          children: {
            company: void 0,
            policy: void 0,
            expired: { type: DateTimeTypes.ShortDate },
          },
        }),
        liability: group({
          children: {
            company: void 0,
            policy: void 0,
            expired: { type: DateTimeTypes.ShortDate },
          },
        }),
        tracking: array({
          children: subContractor.tracking.map((item) => group({
            key: item.value,
            children: {
              value: void 0,
              name: void 0,
              selected: void 0,
            },
          })),
        }),
      },
    });
  }
}
